import { Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate, Router } from '@angular/router';
import { DbService } from './db-service/db.service';

@Injectable({
  providedIn: 'root'
})
export class HomeGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _dbService: DbService,
    private router: ActivatedRoute
  ) {
  }

  canActivate() {

    if (this._dbService.getBusinessId()) {
      this._router.navigate(['/admin/home']);
      return false;
    }

    return true;
  }

}
